(function () {
  'use strict';

  var QMAX = 99;

  function refreshCart(added) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (added && added.sections) cart.sections = added.sections;
        try {
          if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
            window.FoxTheme.pubsub.publish(
              window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
              { cart: cart }
            );
          }
        } catch (error) {}

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          try { drawer.show(); return; } catch (error) {}
        }
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: true }
          }));
        } catch (error) {}
      })
      .catch(function () {
        /* The item was added. The inline confirmation remains the fallback. */
      });
  }

  function addItems(items) {
    var validItems = (items || []).filter(function (item) {
      return item && parseInt(item.id, 10) > 0 && parseInt(item.quantity, 10) > 0;
    });
    if (!validItems.length) return Promise.reject(new Error('No available paste packs were selected.'));

    var sections = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));
    } catch (error) {}

    var payload = { items: validItems };
    if (sections.length) {
      payload.sections = sections.join(',');
      payload.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.text().then(function (text) {
          var data = null;
          try { data = JSON.parse(text); } catch (error) {}
          if (!response.ok) {
            throw new Error(
              (data && (data.description || data.message)) ||
              ('Could not add to cart (error ' + response.status + ').')
            );
          }
          return data;
        });
      })
      .then(function (data) {
        return refreshCart(data).then(function () { return data; });
      });
  }

  function initForm(form) {
    if (form.getAttribute('data-dc-wired') === 'true') return;
    form.setAttribute('data-dc-wired', 'true');

    var radios = form.querySelectorAll('input.dcsz');
    var quantity = form.querySelector('input.dcq');
    var price = form.querySelector('[data-prc]');
    var message = form.querySelector('[data-msg]');
    var submit = form.querySelector('button.dcatc');
    var minus = form.querySelector('.dcqm');
    var plus = form.querySelector('.dcqp');

    function selected() {
      for (var index = 0; index < radios.length; index += 1) {
        if (radios[index].checked && !radios[index].disabled) return radios[index];
      }
      return null;
    }

    function say(text, isError) {
      if (!message) return;
      message.textContent = text || '';
      message.className = 'dcmsg' + (text ? (isError ? ' bad' : ' ok') : '');
    }

    function clampQuantity() {
      if (!quantity) return 1;
      var value = parseInt(quantity.value, 10);
      if (isNaN(value) || value < 1) value = 1;
      if (value > QMAX) value = QMAX;
      quantity.value = value;
      if (minus) minus.disabled = value <= 1;
      if (plus) plus.disabled = value >= QMAX;
      return value;
    }

    function sync() {
      var radio = selected();
      if (!radio) {
        if (price) price.textContent = '';
        if (submit) submit.disabled = true;
        return;
      }
      if (price) {
        var liquidPrice = radio.getAttribute('data-price') || '';
        var packSize = radio.getAttribute('data-size') || '';
        price.innerHTML = '<b>' + liquidPrice + '</b><span>each · ' + packSize + '</span>';
      }
      if (submit) submit.disabled = false;
    }

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', function () {
        say('');
        sync();
      });
    });

    if (quantity) {
      quantity.addEventListener('input', clampQuantity);
      quantity.addEventListener('change', clampQuantity);
      quantity.addEventListener('blur', clampQuantity);
    }
    if (minus) minus.addEventListener('click', function () {
      var value = clampQuantity();
      quantity.value = Math.max(1, value - 1);
      clampQuantity();
    });
    if (plus) plus.addEventListener('click', function () {
      var value = clampQuantity();
      quantity.value = Math.min(QMAX, value + 1);
      clampQuantity();
    });

    clampQuantity();
    sync();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var radio = selected();
      if (!radio) {
        say('Choose an available pack size.', true);
        return;
      }

      var variantId = parseInt(radio.value, 10);
      var count = clampQuantity();
      if (!variantId) {
        say('This pack size cannot be added right now.', true);
        return;
      }

      var originalLabel = submit ? submit.innerHTML : '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding…';
      }

      addItems([{ id: variantId, quantity: count }])
        .then(function () {
          if (submit) {
            submit.disabled = false;
            submit.innerHTML = originalLabel;
          }
          say('Added to cart: ' + count + ' × ' + radio.getAttribute('data-size') + '.', false);
        })
        .catch(function (error) {
          if (submit) {
            submit.disabled = false;
            submit.innerHTML = originalLabel;
          }
          say(error && error.message ? error.message : 'Could not add to cart. Check your connection and try again.', true);
        });
    });
  }

  function init(scope) {
    var root = scope || document.getElementById('dcpaste');
    if (!root) return;
    var forms = root.matches && root.matches('form.dcbuy') ? [root] : root.querySelectorAll('form.dcbuy');
    Array.prototype.forEach.call(forms, initForm);
  }

  window.DcPasteBuy = { init: init, addItems: addItems };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
